import TYPES from './types';

const INITIAL_STATE = {
  profile: null,
  historyDeployments: []
};

export default function (state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case TYPES.UPDATE_PERSON.SUCCESS:
      return {
        ...state,
        profile: payload
      };

    case TYPES.GET_PERSON.START:
    case TYPES.GET_PERSON.ERROR:
      return {
        ...state,
        profile: null
      };

    case TYPES.GET_PERSON.SUCCESS:
      return {
        ...state,
        profile: payload
      };

    case TYPES.GET_VESSEL_DEPLOYMENT_HISTORY.SUCCESS:
      return {
        ...state,
        historyDeployments: payload?.data
      };

    case TYPES.GET_VESSEL_DEPLOYMENT_HISTORY.START:
    case TYPES.GET_VESSEL_DEPLOYMENT_HISTORY.ERROR:
      return {
        ...state,
        profile: null,
        historyDeployments: []
      };

    default:
      return state;
  }
}
